import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { EpdDashboardHeaderControlsComponent } from '../epd-dashboard-header-controls/epd-dashboard-header-controls.component';
import { PCR, Standard } from '../../utils/epd-dashboard.model';

@Component({
  selector: 'app-epd-dashboard-header',
  standalone: true,
  imports: [CommonModule, EpdDashboardHeaderControlsComponent],
  templateUrl: './epd-dashboard-header.component.html',
  styleUrls: ['./epd-dashboard-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdDashboardHeaderComponent {
  @Input() productName: string;
  @Input() standardLogo: string | null = null;
  @Input() selectedPcr: PCR;
  @Input() dataUpdated;
  @Input() selectedMethod: Standard;
  @Input() methodList: Standard[] = [];
  @Input() pcrList: PCR[] = [];
  @Input() languages: any[] | null = null;
  @Input() selectedLanguage;
  @Input() canPreview = false;
  @Input() previewButtonLabel = 'Preview & Export';

  @Output() methodologyChange = new EventEmitter<Standard[]>();
  @Output() pcrChange = new EventEmitter<PCR[]>();
  @Output() languageChange = new EventEmitter<any[]>();
  @Output() preview = new EventEmitter<void>();
}
